import React from 'react';
import { BkWebApp } from 'bk-web-app';
import UserAssignmentsComponent from 'user-assignments';

const UserAssignments = props => (
  <BkWebApp isToastContainerApp>
    <UserAssignmentsComponent {...props} />
  </BkWebApp>
);

export default UserAssignments;
